import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { post, get } from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('bb_user')); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const refreshUser = useCallback(async () => {
    if (!localStorage.getItem('bb_token')) return;
    const current = await get('/auth/me');
    if (current?.id) {
      localStorage.setItem('bb_user', JSON.stringify(current));
      setUser(current);
    }
  }, []);
  useEffect(() => {
    const refresh = () => { refreshUser().catch(() => {}); };
    refresh();
    window.addEventListener('focus', refresh);
    return () => window.removeEventListener('focus', refresh);
  }, [refreshUser]);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const data = await post('/auth/login', { email, password });
      const userData = { ...data.user, permissions: data.user.permissions || [] };
      localStorage.setItem('bb_token', data.token);
      localStorage.setItem('bb_user', JSON.stringify(userData));
      setUser(userData);
      return userData;
    } finally { setLoading(false); }
  };

  const logout = async () => {
    try { await post('/auth/logout', {}); } catch {}
    localStorage.removeItem('bb_token');
    localStorage.removeItem('bb_user');
    setUser(null);
  };

  const hasPermission = (perm) => {
    if (!user) return false;
    if (user.role === 'super_admin') return true;
    return user.permissions?.includes(perm);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, hasPermission, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
